import {
  InformationOutline18Icon,
  LinkOutOutline18Icon,
} from "@vygruppen/spor-icon-react";
import { ISirkModuleForShifts } from "features/CenterContent/RoleContent/ISirk/ISirkModuleForShifts";
import { SimpleHeadedContainerSticky } from "features/CenterContent/VehicleDetails/shared/SimpleHeadedContainerSticky";
import { generatePath, useNavigate } from "react-router-dom";
import {
  DropsBadge,
  DropsButton,
  HStack,
  Text,
  DropsTooltip,
} from "shared/components/Spor";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import { LANDING } from "shared/utils/routes";
import { useDropsRole } from "stores/useDropsRole";
import { css, useTheme } from "styled-components";

const SimpleSharedGridStyleNoPadding = css`
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  padding-left: 12px;
  padding-right: 12px;
  border-radius: 6px;
`;

interface ISirkPanelProps {
  vehicle: AlternativeTransportVehicle;
}

export const ISirkPanel = ({ vehicle }: ISirkPanelProps) => {
  const navigate = useNavigate();
  const { role } = useDropsRole();
  const shiftDate = vehicle?.workShiftPlan?.shiftDate;
  const shiftId = vehicle?.workShiftPlan?.shiftId;
  const operatorName = vehicle?.operatorName;
  const theme = useTheme();

  return (
    <SimpleHeadedContainerSticky
      panelStyle={SimpleSharedGridStyleNoPadding}
      headerHeight="54px"
      variant="main"
      headingLeft={
        <HStack gap="6px">
          <Text>I-sirklogg</Text>
          <DropsTooltip
            style={{
              width: "220px",
              color: theme.colorBackgroundMain,
              backgroundColor: theme.colorSuccessTextSecondary,
              padding: "6px",
              borderRadius: "12px",
            }}
            label="Denne loggen sendes til i-sirkloggen. Her vises kun det som er lagt inn på dette skiftet. Kundeveiledere har ikke tilgang til denne loggen."
          >
            <InformationOutline18Icon />
          </DropsTooltip>
        </HStack>
      }
      headingRight={
        <>
          <DropsBadge p={1} semantics="transparent" fontWeight="600">
            {vehicle?.workShiftPlan?.isirkId || "ukjent"}
          </DropsBadge>
          <DropsButton
            size="xs"
            fontSize="xs"
            variant="tertiary"
            onClick={() =>
              navigate(
                generatePath(LANDING, {
                  roleIdParam: role,
                  tabIdParam: "start",
                }),
              )
            }
          >
            I-sirklogg <LinkOutOutline18Icon />
          </DropsButton>
        </>
      }
    >
      <ISirkModuleForShifts
        selectedDate={shiftDate?.toString() ?? ""}
        shiftId={shiftId ?? ""}
        operatorName={operatorName || ""}
      />
    </SimpleHeadedContainerSticky>
  );
};
